import axios from './http';

export const sendEmail = (data) => axios.post('email', data);
